<div class="form-group mb-20">
    <label class="col-xs-10 control-label text-left">{{ "control_text_color" | translate }}</label>
    <div class="col-xs-2">
        <sp-color-picker-v2
            [hideGradient]="true"
            [color]="colorValue()"
            [colorsPreset]="colorsPreset()"
            (colorChangeEvent)="setColor($event)"
        />
    </div>
</div>

<div class="form-group mb-20">
    <label class="col-xs-10 control-label text-left">{{ "control_background_color" | translate }}</label>
    <div class="col-xs-2">
        <sp-color-picker-v2
            [color]="backgroundValue()"
            [colorsPreset]="colorsPreset()"
            (colorChangeEvent)="setBackground($event)"
        />
    </div>
</div>

<div class="form-group mb-20">
    <label class="col-xs-12">{{ "control_contour" | translate }}</label>
    <div class="col-xs-4">
        <sp-input-num
            suffixText="px"
            [min]="BORDER_WIDTH_MIN"
            [max]="BORDER_WIDTH_MAX"
            [onlyIntegers]="true"
            [value]="borderWidth()"
            (valueChange)="setBorderWidth($event)"
            (blurEvent)="setBorderWidth($event)"
        />
    </div>
    <div class="col-xs-6">
        <sp-input-num
            prefixImgUrl="./assets/img/border-radius-icon.svg"
            suffixText="px"
            [min]="BORDER_RADIUS_MIN"
            [max]="BORDER_RADIUS_MAX"
            [onlyIntegers]="true"
            [value]="borderRadius()"
            (valueChange)="setBorderRadius($event)"
            (blurEvent)="setBorderRadius($event)"
        />
    </div>
    <div class="col-xs-2">
        <sp-color-picker-v2
            [hideGradient]="true"
            [positionLeft]="true"
            [color]="borderColorValue()"
            [colorsPreset]="colorsPreset()"
            (colorChangeEvent)="setBorderColor($event)"
        />
    </div>
</div>

<div class="form-group">
    <label class="col-xs-12">{{ "control_hover_effect" | translate }}</label>
    <div
        [class.col-xs-8]="hoverValue().hoverType === EButtonHoverType.opacity"
        [class.col-xs-12]="hoverValue().hoverType !== EButtonHoverType.opacity"
    >
        <select class="form-control" (change)="changeHoverType($event)">
            @for (option of hoverOptions; track option.value) {
                <option [value]="option.value" [selected]="option.value === hoverValue().hoverType">
                    {{ option.label | translate }}
                </option>
            }
        </select>
    </div>
    @if (hoverValue().hoverType === EButtonHoverType.opacity) {
        <div class="col-xs-4">
            <sp-input-num
                suffixText="%"
                [min]="OPACITY_MIN"
                [max]="OPACITY_MAX"
                [value]="hoverValue().opacity"
                (valueChange)="setOpacity($event)"
                (blurEvent)="setOpacity($event)"
            />
        </div>
    }
</div>

@if (hoverValue().hoverType === EButtonHoverType.color) {
    <div class="alternative-color-settings">
        <div class="form-group mb-10">
            <label class="col-xs-9 control-label">{{ "control_text_color" | translate }}</label>
            <div class="col-xs-3">
                <sp-color-picker-v2
                    [hideGradient]="true"
                    [color]="hoverColorValue()"
                    [colorsPreset]="colorsPreset()"
                    (colorChangeEvent)="setHoverColor($event)"
                />
            </div>
        </div>
        <div class="form-group mb-10">
            <label class="col-xs-9 control-label">{{ "control_background_color" | translate }}</label>
            <div class="col-xs-3">
                <sp-color-picker-v2
                    [hideGradient]="true"
                    [color]="hoverBackgroundValue()"
                    [colorsPreset]="colorsPreset()"
                    (colorChangeEvent)="setHoverBackground($event)"
                />
            </div>
        </div>
        <div class="form-group">
            <label class="col-xs-9 control-label">{{ "control_contour_color" | translate }}</label>
            <div class="col-xs-3">
                <sp-color-picker-v2
                    [hideGradient]="true"
                    [color]="hoverBorderColorValue()"
                    [colorsPreset]="colorsPreset()"
                    (colorChangeEvent)="setHoverBorderColor($event)"
                />
            </div>
        </div>
    </div>
}
